import {Component, effect, input, output, signal, Signal} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ApiInterfaceModel} from "../../../models/resources/api-interface.model";
import {ReadOnlyInputComponent} from "../../utils/read-only-input/read-only-input.component";
import {LinkSelectComponent} from "../../utils/link-select/link-select.component";
import {CustomerService} from "../../../services/resources/customer.service";

@Component({
  selector: 'app-api-interface-customer-form',
  imports: [
    ReactiveFormsModule,
    ReadOnlyInputComponent,
    LinkSelectComponent
  ],
  templateUrl: './api-interface-customer-form.component.html',
  styleUrl: './api-interface-customer-form.component.scss',
})
export class ApiInterfaceCustomerFormComponent {
  formGroupOutput = output<FormGroup>();
  formGroup: Signal<FormGroup>;
  apiInterface = input<ApiInterfaceModel>();

  constructor(private formBuilder: FormBuilder,
              public customerService: CustomerService) {
    this.formGroup = signal(this.formBuilder.group({
      apiInterface: [null, [Validators.required]],
      customer: [null, [Validators.required]]
    }));

    effect(() => {
      this.formGroupOutput.emit(this.formGroup());
    });

    effect(() => {
      if(this.apiInterface())
        this.formGroup().get('apiInterface')?.setValue(this.apiInterface()!);
    });
  }
}
